// extracted by mini-css-extract-plugin
export default {"root":"ManualFilesUploadSidebar_root__kjxBM"};